export const P = {
  s0: 'hsl(230,18%,6%)',
  s1: 'hsl(228,14%,9%)',
  s2: 'hsl(226,11%,13%)',
  s3: 'hsl(224,9%,17%)',

  border: 'hsl(230,12%,15%)',
  borderSub: 'hsl(230,12%,11%)',

  t1: 'hsl(210,15%,90%)',
  t2: 'hsl(215,10%,58%)',
  t3: 'hsl(225,10%,34%)',

  accent: 'hsl(185,90%,52%)',
  pos: 'hsl(162,80%,48%)',
  neg: 'hsl(340,75%,58%)',
  warn: 'hsl(45,90%,55%)',
  info: 'hsl(210,80%,60%)',

  disabled: 'hsl(225,10%,28%)',
  disabledBg: 'hsl(230,12%,8%)',

  sEx: 'hsl(162,80%,48%)',
  sGood: 'hsl(170,65%,52%)',
  sOk: 'hsl(45,90%,55%)',
  sFrag: 'hsl(18,80%,55%)',
  sCrit: 'hsl(340,75%,58%)',

  bReal: 'hsl(162,80%,48%)',
  bScenario: 'hsl(210,80%,60%)',
  bHist: 'hsl(225,10%,40%)',
  bComp: 'hsl(45,90%,55%)',

  dForked: 'hsl(210,80%,60%)',
  dAdded: 'hsl(162,80%,48%)',
  dDeleted: 'hsl(340,75%,58%)',
} as const;

export type PaletteKey = keyof typeof P;

export const ghost = {
  pos: { bg: 'hsla(162,80%,48%,0.10)', border: 'hsla(162,80%,48%,0.20)' },
  neg: { bg: 'hsla(340,75%,58%,0.10)', border: 'hsla(340,75%,58%,0.20)' },
  warn: { bg: 'hsla(45,90%,55%,0.06)', border: 'hsla(45,90%,55%,0.14)' },
  accent: { bg: 'hsla(185,90%,52%,0.08)', border: 'hsla(185,90%,52%,0.18)' },
  info: { bg: 'hsla(210,80%,60%,0.10)', border: 'hsla(210,80%,60%,0.20)' },
  muted: { bg: 'hsla(225,10%,34%,0.15)', border: 'hsla(225,10%,34%,0.25)' },
} as const;

export type GhostKey = keyof typeof ghost;

const GA = 137.508;
export function cCol(i: number): string {
  return `hsl(${Math.round((195 + i * GA) % 360)},68%,55%)`;
}

export function fmt(v: number): string {
  // 2 décimales max : les montants peuvent porter des centimes (P1 révisé),
  // et le plafond absorbe les résidus flottants des conversions /12 ×12.
  return Math.abs(v).toLocaleString('de-CH', { maximumFractionDigits: 2 });
}

export function eoc(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}
